import { observable, runInAction, action, makeObservable } from "mobx";
import { userInfoStore } from "Stores/UserInfoStore";
import { API } from "General/API";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import i18n, { I18N_NS } from "Config/i18n";
import { API_URL } from "General/APIEndpoints";

interface InputValues {
  newPassword: string;
  newPasswordConfirmation: string;
  oldPassword: string;
}

class SecurityStore {
  errorMessage: string = null;

  constructor() {
    makeObservable(this, {
      errorMessage: observable,
      resetErrorMessage: action.bound,
      submit: action.bound,
    });

    this.errorMessage = null;
  }

  defineErrorMessage(code: number) {
    const errors = {
      1027: "Old password is wrong",
      1060: "New password does not match the required quality",
      1061: "New password is too close to a recently used old password",
      1062: "Password is not secure because it is on a black list of known passwords",
      1011: "You are not allowed to change password.",
      1014: "Password does not match the security requirements.",
      1012: "REDIRECT",
      1015: "REDIRECT",
    };
    return errors[code];
  }

  resetErrorMessage() {
    this.errorMessage = null;
  }

  async submit(values: InputValues) {
    try {
      this.errorMessage = null;
      let url: string;
      if (userInfoStore.loginInfo.unifiedAccount) {
        url = API_URL.PAVE_USERS.updateLinkedUserPassword(userInfoStore.id);
      } else {
        url = API_URL.USERS.updateUserPassword(userInfoStore.id);
      }
      const response = await API.editData(url, values, {
        sendInfoMail: true,
      });
      runInAction(() => {
        if (response) {
          notificationSuccess(
            i18n.t("Success", { ns: I18N_NS.USER_SETTINGS }),
            i18n.t("Password changed", { ns: I18N_NS.USER_SETTINGS })
          );
          this.resetErrorMessage();
        }
      });
    } catch (err) {
      runInAction(() => {
        if (err.response) {
          if (err.response.status === 403) {
            this.errorMessage = "You have no rights to change password";
          } else if (err.response.status === 409) {
            if (err.response.data) {
              this.errorMessage = this.defineErrorMessage(err.response.data.code);
            }
            this.errorMessage = "Password does not fit the requirements";
          } else {
            this.errorMessage = "Error: Unknown!";
          }
        } else {
          this.errorMessage = "Error: Unknown!";
        }
      });
      throw err;
    }
  }
}

const securityStore = new SecurityStore();

export { securityStore, SecurityStore };
